module.exports = __webpack_public_path__ + "static/molecules-49b9596a0cd54825575124c4518cca41.svg";